export const api =
"https://raw.githubusercontent.com/thomas37000/my-portfolio/main/src/projetsWild.json";
